export default "__VITE_PUBLIC_ASSET__4c9eef5c__"